// repo/primary-care-connect/frontend/src/pages/Portal/CommunityNavigator/CaseDetail/components/TextList.tsx

type TextListProps = {
  items: string[];
  emptyText: string;
};

export default function TextList({ items, emptyText }: TextListProps) {
  if (!items.length) {
    return <p className="cn-case-detail-muted">{emptyText}</p>;
  }

  return (
    <ul className="cn-case-detail-chip-list">
      {items.map((item, index) => (
        <li key={`${item}-${index}`}>{item}</li>
      ))}
    </ul>
  );
}